var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLogin == false)?_c('div',[_c('common-header'),_c('login')],1):_c('div',[_c('common-header'),_c('file-upload')],1)}
var staticRenderFns = []

export { render, staticRenderFns }